import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["isLoading"];
import { LayoutBox } from '../Layout/LayoutBox';
import { Checkbox } from '../Checkbox/Checkbox';
import { Skeleton } from '../Skeleton/Skeleton';
import { jsx as _jsx } from "react/jsx-runtime";
const CHECKBOX_SIZE = '1.25rem';
export const GridListCheckbox = _ref => {
  let {
      isLoading
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx(Skeleton, {
    blockSize: CHECKBOX_SIZE,
    flex: "0 0 auto",
    inlineSize: CHECKBOX_SIZE,
    isLoading: isLoading,
    children: /*#__PURE__*/_jsx(LayoutBox, {
      flex: "0 0 auto",
      children: /*#__PURE__*/_jsx(Checkbox, Object.assign({}, rest, {
        tabIndex: 0
      }))
    })
  });
};